<div class="p-checkbox p-component" (click)="onClick($event)">
  <div class="p-hidden-accessible">
    <input
      #cb
      type="checkbox"
      [attr.id]="inputId"
      [attr.name]="name"
      [checked]="checked"
      (focus)="onFocus()"
      (blur)="onBlur()"
      [disabled]="isDisabled()"
      [attr.aria-label]="ariaLabel"
    />
  </div>
  <div
    #box
    [ngClass]="{ 'p-checkbox-box': true, 'p-highlight': checked || multipleEntriesSelected, 'p-disabled': isDisabled() }"
    role="checkbox"
    [attr.aria-checked]="checked"
  >
    <span
      class="p-checkbox-icon"
      [ngClass]="{ pi: checked || multipleEntriesSelected, 'pi-check': checked, 'pi-minus': multipleEntriesSelected && !checked }"
    ></span>
  </div>
</div>
